import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAllFormatos = ()  => {
    const api = useApi();

    const mutate = async (active) => {
        const data  = await api.get(`/formatos-etiquetas${active}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllFormatosMutation: mutation.mutate,
    };
}
